import Select from "react-select";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../StyleSheet/MainComponent/Role/CreateMail.scss";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import {
  faCheckSquare,
  faSquare,
  faAngleDown,
  faAngleRight,
  faSquareMinus,
  faFolder,
  faFolderOpen,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import {
  setprojectListgetdropActions,
  setplantListgetdropActions,
  setFileListRetrieveActions,
  setprojectwbsListgetdropActions,
  CreateScheduleActions,
  UpdateScheduleResponse,
  SetFileListUpdateSuccessResponse,
  SetFileListUpdateprojectSuccessResponse,
  SetFileListUpdateprojectwbsSuccessResponse,
  // setFileListUpdateActions,
} from "../../Redux/Slice";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import emailDash from "../../Assets/AppComponent/Images/emailDash.svg";

import Header from "../../Component/AppComponent/Header/Header";
import Swal from "sweetalert2";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { CKEditor } from "ckeditor4-react";
import axios from "axios";
import { filedownload } from "../../Context/apidata";
import { store } from "../../Redux/Store";
import pdf from "../../Assets/AppComponent/Images/doc.jpg";
import { DatePicker, Stack } from "rsuite";
import isBefore from "date-fns/isBefore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isSameDay } from "date-fns";
import { da } from "date-fns/locale";

function CreateMail() {
  const [data, setData] = useState({
    email_to: [],
    email_cc: [],
    subject: "",
    email_body: "",
    plant: "",
    plant_name: "",
    project: "",
    project_name: "",
    project_wbs: "",
    project_wbs_name: "",
    file_path: [],
    schedule_datetime: "",
    amount: "",
  });
  console.log(data, "email_body");
  const formdata = new FormData();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filetypearray, setfiletypearray] = useState([]);
  const [Files, setFiles] = useState([]);
  const [error, seterror] = useState(false);
  const filename = [];
  var serialNumber = 1;
  var serialNumber2 = 1;
  const encounteredLastNames = new Set();
  const encounteredLastNames1 = new Set();
  const encounteredLastNames2 = new Set();
  const encounteredLastNames3 = new Set();
  const encounteredLastNames4 = new Set();
  const encounteredLastNames5 = new Set();
  const [InvoiceFileList, setInvoiceFileList] = useState([]);

  const inputFields = [
    // { label: "To", id: "email_to", name: "email_to", value: data.email_to },
    { label: "SUBJECT", id: "subject", name: "subject", value: data.subject },
  ];
  const customIcons = {
    check: (
      <FontAwesomeIcon
        icon={faCheckSquare}
        style={{
          color: "#f26639",
          border: "2px solid #ffff",
          backgroundColor: "#ffff",
          // width: "27px",
          // height: "27px",
          width: "20px",
          height: "20px",
        }}
      />
    ),
    uncheck: (
      <FontAwesomeIcon
        icon={faSquare}
        style={{
          color: "#ffff",
          border: "2px solid #f26639",
          width: "20px",
          height: "20px",
        }}
      />
    ),
    halfCheck: (
      <FontAwesomeIcon
        icon={faSquareMinus}
        style={{
          color: "#f26b39",
          width: "20px",
          height: "20px",
          border: "2px solid #ffff",
        }}
      />
    ),
    expandClose: (
      <FontAwesomeIcon
        icon={faAngleRight}
        style={{
          color: "#f26b39",
          width: "15px",
          height: "15px",
          border: "2px solid #ffff",
          outline: "none",
        }}
      />
    ),
    expandOpen: (
      <FontAwesomeIcon
        icon={faAngleDown}
        style={{
          color: "#f26b39",
          width: "15px",
          height: "15px",
          border: "2px solid #ffff",
        }}
      />
    ),
    parentOpen: (
      <FontAwesomeIcon
        icon={faFolderOpen}
        style={{ color: "#f76639", width: "20px", height: "20px" }}
      />
    ),
    parentClose: (
      <FontAwesomeIcon
        icon={faFolder}
        style={{ color: "#f26b39", width: "20px", height: "20px" }}
      />
    ),
    leaf: (
      <FontAwesomeIcon
        icon={faFile}
        style={{ color: "#f26b39", width: "20px", height: "20px" }}
      />
    ),
  };

  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        background: isFocused
          ? "rgba(242, 102, 57, 0.7)"
          : isDisabled
          ? "rgb(255,255,255)"
          : "transparent",
        color: isFocused ? "white" : "black",
        ":active": {
          backgroundColor: "rgba(242, 102, 57, 0.7)",
        },
      };
    },
  };
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: emailDash,
      title: "MAIL DASHBOARD",
    },
  ];
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const fileRetriveList = useSelector(
    (state) => state.fetchFile.fileRetriveList
  );
  const [emailSent, setEmailSent] = useState([
    { input1: null, input2: null, input3: true },
  ]);

  const currentDateTime = new Date();
  const [plantNameFeeder, setPlantNameFeeder] = useState([]);
  const [projectNameFeeder, setProjectNameFeeder] = useState([]);
  const [projectWbsNameFeeder, setProjectWbsNameFeeder] = useState([]);
  const [treeNameFeeder, setTreeNameFeeder] = useState([]);
  const [treeNameFeederproject, setTreeNameFeederproject] = useState([]);
  const [treeNameFeederprojectwbs, setTreeNameFeederprojectwbs] = useState([]);
  console.log(
    treeNameFeeder,
    treeNameFeederproject,
    treeNameFeederprojectwbs,
    "sdkahaajkhkdasj"
  );
  const [contactno, setcontactno] = useState("");
  const [contactname, setcontactname] = useState("");
  const [invoiceAmount, setinvoiceAmount] = useState("");
  const dispatch = useDispatch();
  const fileNames = useSelector((state) => state.fetchFile.fileListRetrieve);
  const plantemails = useSelector((state) => state.fetchFile.plantemails);
  const fileNamesproject = useSelector(
    (state) => state.fetchFile.fileListRetrieveproject
  );
  const fileNamesprojectwbs = useSelector(
    (state) => state.fetchFile.fileListRetrieveprojectwbs
  );
  const plantNames = useSelector(
    (state) => state.plantListgetdropdata.plantListgetdrop
  );
  const projectNames = useSelector(
    (state) => state.projectListgetdropdata.projectListgetdrop
  );
  const projectWbsNames = useSelector(
    (state) => state.projectwbsListgetdropdata.projectwbsListgetdrop
  );
  const createScheduleResponse = useSelector(
    (state) => state.createSchedule.createScheduleData
  );
  const [ckInitEditor, setckInitEditor] = useState("");
  console.log(fileNames, "sakdjakjsdkjasdkj");

  const [fieldErrors, setFieldErrors] = useState({
    region: "",
    email_to: "",
    email_cc: "",
    subject: "",
    plant: "",
    project_name: "",
    email_body: "",
    date: "",
    time: "",
    schedule_datetime: "",
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [plantSelected, setPlantSelected] = useState([]);
  const [projectSelected, setProjectSelected] = useState([]);
  const [projectWbsSelected, setProjectWbsSelected] = useState([]);
  const [treeFileSelected, setTreeFileSelected] = useState([]);
  const [treeFileSelectedproject, setTreeFileSelectedproject] = useState([]);
  const [treeFileSelectedprojectwbs, setTreeFileSelectedprojectwbs] = useState(
    []
  );
  const [expanded, setExpanded] = useState([]);
  const [expandedproject, setExpandedproject] = useState([]);
  const [expandedprojectwbs, setExpandedprojectwbs] = useState([]);

  const currentDate = new Date();
  // <-----------------CC mail content-------------->
  const [date, setDate] = useState("");
  const [filevalidation, setfilevalidation] = useState(false);
  const [plantcc, setplantcc] = useState([]);
  const [projectcc, setprojectcc] = useState([]);
  console.log(plantcc, "saddasddflkfklgfd", plantNameFeeder);
  const [currentChangedInput, setCurrentChangedInput] = useState("");
  useEffect(() => {
    // console.log(fileRetriveList.message, "djkasdkjjkajksdjkadkhas");
    if (fileRetriveList && currentChangedInput && currentChangedInput !== "") {
      setEmailSent((prevState) => {
        // Copy the existing state
        const updatedState = [...prevState];

        // Update the first object in the array with the new value
        if (updatedState[0]) {
          updatedState[0][currentChangedInput] =
            fileRetriveList?.email_on_off ?? null;
        }

        return updatedState;
      });
    }
  }, [fileRetriveList]);

  useEffect(() => {
    console.log(emailSent, "djkasdkjjkajksdjkadkhas");
  }, [emailSent]);

  const handleMail = (id) => {
    if (id) {
      const filteredObject = projectNameFeeder.find((obj) => obj.id === id);
      var ccmail = [];
      if (filteredObject.project_emails.length > 0) {
        filteredObject?.project_emails[0]?.cc_email.map((email) => {
          if (!plantcc.includes(email)) {
            ccmail.push(email);
          }
        });
        setData({
          ...data,
          email_cc: [...plantcc, ...(ccmail || [])],
          email_to: filteredObject?.project_emails[0]?.to_email,
        });
        setcontactname(filteredObject?.c_name);
        setcontactno(filteredObject?.c_number);
      } else {
        ccmail = [];
        setData((prev) => {
          return {
            ...prev,
            email_cc: data.email_cc,
            email_to: [],
          };
        });
        setcontactname("");
        setcontactno("");
      }
    }
  };

  // X-----------------CC mail content--------------X
  useEffect(() => {
    dispatch(setplantListgetdropActions());
  }, [dispatch]);
  useEffect(() => {
    if (
      plantSelected.length == 0 &&
      projectSelected.length == 0 &&
      projectWbsSelected.length == 0
    ) {
      dispatch(SetFileListUpdateSuccessResponse([]));
      dispatch(SetFileListUpdateprojectSuccessResponse([]));
      dispatch(SetFileListUpdateprojectwbsSuccessResponse([]));
      setTreeNameFeeder([]);
      setTreeNameFeederproject([]);
      setTreeNameFeederprojectwbs([]);
    }
  }, [plantSelected, projectSelected, projectWbsSelected]);

  useEffect(() => {
    if (plantSelected.length !== 0) {
      dispatch(setprojectListgetdropActions({ id: plantSelected[0].value }));
      const payload = {
        directory_path: `${plantSelected[0]?.label}`,
        plant: "True",
      };
      dispatch(setFileListRetrieveActions(payload));
    }
  }, [plantSelected]);

  useEffect(() => {
    if (projectSelected.length !== 0) {
      dispatch(
        setprojectwbsListgetdropActions({ id: projectSelected[0].value })
      );

      const formattedDate = currentDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
      });
      setData({
        ...data,
        // subject: `Attachment (Date: ${formattedDate}): Invoice Processing for ${data.project_name}  from UDS. `,
        // subject: `${data.project_name} - Attachment (Date: ${formattedDate})`,
        subject: `${contactname}-${date.toUpperCase()}`,
      });
    }
  }, [projectSelected, dispatch, date]);

  useEffect(() => {
    if (projectWbsSelected.length !== 0) {
      const payload = {
        directory_path: `${plantSelected[0]?.label}/${projectSelected[0]?.label}/${projectWbsSelected[0].label}/`,
        wbs: true,
      };
      dispatch(setFileListRetrieveActions(payload));
    }
  }, [projectWbsSelected, projectSelected, dispatch]);

  useEffect(() => {
    setPlantNameFeeder(plantNames);
  }, [plantNames]);

  useEffect(() => {
    setProjectNameFeeder(projectNames);
  }, [projectNames]);
  // <---------Setting project wbs list in ProjectWbsNameFeeder.--------------->

  useEffect(() => {
    setProjectWbsNameFeeder(projectWbsNames);
  }, [projectWbsNames]);

  // <---------Auto select all files--------------->
  useEffect(() => {
    if (treeNameFeeder.length > 0) {
      const fileList = treeNameFeeder.flatMap((item) =>
        item.children.map((child) => child.value)
      );
      setTreeFileSelected(fileList);
    }
  }, [treeNameFeeder]);

  useEffect(() => {
    if (treeNameFeederproject.length > 0) {
      const fileList1 = treeNameFeederproject.flatMap((item) =>
        item.children.map((child) => child.value)
      );
      //console.log(fileList1, "adkhahfs");
      setTreeFileSelectedproject(fileList1);
    }
  }, [treeNameFeederproject]);

  useEffect(() => {
    const fileList2 = treeNameFeederprojectwbs.flatMap((item) =>
      item.children.map((child) => child.value)
    );

    setTreeFileSelectedprojectwbs(fileList2);
  }, [treeNameFeederprojectwbs]);

  useEffect(() => {
    if (projectSelected.length !== 0 && projectWbsSelected.length == 0) {
      dispatch(
        setFileListRetrieveActions(
          `${plantSelected[0]?.label}/${projectSelected[0]?.label}/`
        )
      );
    }
    if (
      projectSelected.length == 0 &&
      projectWbsSelected.length == 0 &&
      plantSelected.length != 0
    ) {
      setckInitEditor(
        `
        <p>Dear Sir / Madam</p> 
     
    <p>Greetings from UDS!</p> 
     
   <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
     
    <p>Please find attached invoices along with support documents for services rendered month of: ${
      date != "" ? date : ""
    }</p>
<p>Invoice# <br/> 
[${
          InvoiceFileList.length > 0 &&
          InvoiceFileList.map((ele, index) => {
            return `${`<span>${ele}</span>`}`;
          })
        }]
        </p> 
<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p> `
      );
      setData((prev) => {
        return {
          ...prev,
          invoice_id: InvoiceFileList,
          email_body: `
          <p>Dear Sir / Madam</p> 
       
      <p>Greetings from UDS!</p> 
       
     <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
       
      <p>Please find attached invoices along with support documents for services rendered month of: ${
        date != "" ? date : ""
      }</p>
      <p>Invoice# <br/> 
      [${
        InvoiceFileList.length > 0 &&
        InvoiceFileList.map((ele, index) => {
          return `${`<span>${ele}</span>`}`;
        })
      }]
      </p> 
<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p>`,
        };
      });
    }
  }, [projectSelected, plantSelected, dispatch]);

  useEffect(() => {
    if (fileNames.length > 0) {
      setTreeNameFeeder(fileNames);

      fileNames.map((ele) => {
        if (ele.children.length === 0 && filevalidation == false) {
          setfilevalidation(true);
        }
      });
      const allHaveChildren = fileNames.every((ele) => ele.children.length > 0);

      if (allHaveChildren && filevalidation == false) {
        setfilevalidation(false);
      }
    }

    if (fileNamesproject.length > 0) {
      //console.log(fileNamesproject, "plplpl");
      setTreeNameFeederproject(fileNamesproject);
      fileNamesproject.map((ele) => {
        if (ele.children.length === 0 && filevalidation == false) {
          setfilevalidation(true);
        }
      });
      const allHaveChildren = fileNamesproject.every(
        (ele) => ele.children.length > 0
      );

      if (allHaveChildren && filevalidation == false) {
        setfilevalidation(false);
      }
    }

    if (fileNamesprojectwbs.length > 0) {
      setTreeNameFeederprojectwbs(fileNamesprojectwbs);
      fileNamesprojectwbs.map((ele) => {
        if (ele.children.length === 0 && filevalidation == false) {
          setfilevalidation(true);
        }
      });
      const allHaveChildren = fileNamesprojectwbs.every(
        (ele) => ele.children.length > 0
      );

      if (allHaveChildren && filevalidation == false) {
        setfilevalidation(false);
      }
    } else {
      setTreeNameFeederprojectwbs([]);
    }
    //   {
    //   setTreeNameFeeder([])
    // setTreeNameFeederproject([])
    // setTreeNameFeederprojectwbs([])
    // }
  }, [fileNames, fileNamesproject, fileNamesprojectwbs]);

  const HandleChanges = (e) => {
    setFieldErrors((prev) => {
      return {
        ...prev,
        [e.target.name]: "",
      };
    });
    setData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  // const handleDate = (inputDate) => {
  //   const currentDate = new Date();
  //   if (
  //     inputDate instanceof Date &&
  //     !isNaN(inputDate.getTime()) &&
  //     !isBefore(inputDate, currentDate)
  //   ) {
  //     //console.log(inputDate);
  //     var date = new Date(inputDate);
  //     var formattedDate = date
  //       .toISOString()
  //       .replace(/T/, " ")
  //       .replace(/\..+/, "");

  //     setData((prev) => {
  //       return {
  //         ...prev,
  //         schedule_datetime: formattedDate,
  //       };
  //     });
  //   } else {
  //     console.log("Selected Date:", inputDate);
  //     toast.info(`Invalid Date Please Select Future date`, {
  //       position: toast.POSITION.TOP_RIGHT,
  //       className: "toast-message",
  //     });
  //     setData((prev) => {
  //       return {
  //         ...prev,
  //         schedule_datetime: "",
  //       };
  //     });
  //   }
  // };

  const handleDate = (inputDate) => {
    console.log(inputDate, "inputDate");
    const currentDate = new Date();
    if (inputDate) {
      // Check if the selected time is in the future
      if (
        inputDate.getHours() > currentDate.getHours() ||
        (inputDate.getHours() === currentDate.getHours() &&
          inputDate.getMinutes() >= currentDate.getMinutes())
      ) {
        // var date = new Date(inputDate);
        // var formattedDate = date
        //   .toISOString()
        //   .replace(/T/, " ")
        //   .replace(/\..+/, "");
        setSelectedDate(inputDate);
        var year = inputDate.getFullYear();
        var month = ("0" + (inputDate.getMonth() + 1)).slice(-2); // Adding 1 to month because it's zero-based
        var day = ("0" + inputDate.getDate()).slice(-2);
        var hours = ("0" + inputDate.getHours()).slice(-2);
        var minutes = ("0" + inputDate.getMinutes()).slice(-2);
        var seconds = ("0" + inputDate.getSeconds()).slice(-2);
        var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        console.log(formattedDate, date, "inputDate");
        setData((prev) => {
          return {
            ...prev,
            schedule_datetime: formattedDate,
          };
        });
      } else {
        // console.log("Selected Date:", inputDate);
        toast.info(`Invalid Date Please Select Future date`, {
          position: toast.POSITION.TOP_RIGHT,
          className: "toast-message",
        });
        setData((prev) => {
          return {
            ...prev,
            schedule_datetime: "",
          };
        });
        setSelectedDate(null);
      }
    } else {
      // console.log("Selected Date:", inputDate);
      // toast.info(`Invalid Date`, {
      //   position: toast.POSITION.TOP_RIGHT,
      //   className: "toast-message",
      // });
      setData((prev) => {
        return {
          ...prev,
          schedule_datetime: "",
        };
      });
      setSelectedDate(null);
    }
  };

  const onCheck = (treeFileSelected) => {
    setTreeFileSelected(treeFileSelected);
  };

  const onCheck1 = (treeFileSelected1) => {
    //console.log(treeFileSelected1);

    setTreeFileSelectedproject(treeFileSelected1);
  };

  const onCheck2 = (treeFileSelected2) => {
    //console.log(treeFileSelected2, "234");
    setTreeFileSelectedprojectwbs(treeFileSelected2);
  };

  const onExpand = (expanded) => {
    setExpanded(expanded);
  };

  const onExpand1 = (expanded1) => {
    setExpandedproject(expanded1);
  };

  const onExpand2 = (expanded2) => {
    setExpandedprojectwbs(expanded2);
  };
  useEffect(() => {
    var list = [
      ...treeFileSelected,
      ...treeFileSelectedproject,
      ...treeFileSelectedprojectwbs,
    ];
    list.map((path) => {
      if (
        path.includes("DIG_INVOICE") ||
        path.includes("dig_invoice")
        // path.includes("INVOICE") ||
        // path.includes("invoice")
      ) {
        // filename.push(path.substring(path.lastIndexOf("/") + 1).split(".")[0]);
        console.log(path.substring(path.lastIndexOf("/") + 1), "dfkjhdsjk");
        // filename.push(path.substring(path.lastIndexOf("/") + 1).lastIndexOf("."));
        var filenameWithExtension = path.substring(path.lastIndexOf("/") + 1); // Extract filename with extension
        var filenameWithoutExtension = filenameWithExtension.substring(
          0,
          filenameWithExtension.lastIndexOf(".")
        );
        filename.push(filenameWithoutExtension);
      }
    });
    console.log(filename, list, "filename");
    setInvoiceFileList(filename);
    setData({
      ...data,
      invoice_id: filename,
      file_path: list,
    });
    //console.log(filename, "99909");
  }, [treeFileSelected, treeFileSelectedproject, treeFileSelectedprojectwbs]);

  const HandleSubmits = (e) => {
    e.preventDefault();
    const newFieldErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // console.log(
    //   {
    //     ...data,
    //     amount: data.amount,
    //     invoice_id: data.invoice_id,
    //     file_path: data.file_path,
    //     email_cc: data.email_cc,
    //     email_to: data.email_to,
    //   },
    //   "formdataasfdasdfaf"
    // );
    Object.entries(data).forEach(([key, value]) => {
      if (
        key === "schedule_datetime" ||
        key === "file_path" ||
        key === "email_body" ||
        key === "project_wbs_name" ||
        key === "project_wbs"
        // key === "amount"
      ) {
        return;
      }

      if (!value) {
        newFieldErrors[key] = `${
          key.charAt(0).toUpperCase() + key.slice(1)
        } is required.`;
      }
      // else if (key === "email_to" && !emailRegex.test(value)) {
      //   newFieldErrors[key] = "Invalid email format.";
      // }
      else if (key === "plant" && value.length === 0) {
        newFieldErrors[key] = "Select Plant from given options.";
      } else if (key === "project" && value.length === 0) {
        newFieldErrors[key] = "Select project from given options.";
      } else if (key === "amount" && value.length === 0) {
        newFieldErrors[key] = "Invoice Amount Required";
      } else if (key === "amount" && value < 10) {
        newFieldErrors[key] = "Invoice Amount should not be less than 10.";
      } else if (key === "amount" && Number(value) > 10000000000) {
        newFieldErrors[key] =
          "Invoice Amount Should not be more than 10 digits.";
      } else {
        newFieldErrors[key] = "";
      }
    });

    const hasError = Object.values(newFieldErrors).some((error) => error);
    setFieldErrors(newFieldErrors);
    // //console.log(
    //   plantSelected,
    //   projectSelected,
    //   projectWbsSelected,
    //   "Form submitted successfully!"
    // );
    // //console.log(
    //   treeFileSelected,
    //   treeFileSelectedproject,
    //   treeFileSelectedprojectwbs,
    //   "Form submitted successfully!"
    // );
    if (!hasError && contactname != "" && contactno != "" && date != "") {
      // console.log(filevalidation);
      console.log(
        emailSent[0]?.input1,
        "akjsdkjasjkkjlasd6726712",
        emailSent[0]?.input2,
        "kkk",
        emailSent[0]?.input3
      );

      if (
        emailSent[0]?.input1 === false ||
        emailSent[0]?.input2 === false ||
        emailSent[0]?.input3 === false
      ) {
        toast.info(`${fileRetriveList.message} `, {
          position: toast.POSITION.TOP_RIGHT,
          className: "toast-message",
          style: {
            width: "500px",
            right: "25%",
            whiteSpace: "pre-wrap", // Ensure text wraps properly
          },
        });
        console.log(
          {
            ...data,
            amount: data.amount,
            invoice_id: data.invoice_id,
            file_path: data.file_path,
            email_cc: data.email_cc,
            email_to: data.email_to,
          },
          "formdataasfdasdfaf"
        );
      } else {
        if (!filevalidation) {
          Object.keys(data).map((ele) => {
            if (
              ele !== "file_path" &&
              ele !== "email_cc" &&
              ele !== "email_to" &&
              ele !== "invoice_id"
            ) {
              formdata.append(ele, data[ele]);
            }
          });
          formdata.append("invoice_id", JSON.stringify(data.invoice_id));
          formdata.append("file_path", JSON.stringify(data.file_path));
          formdata.append("email_cc", JSON.stringify(data.email_cc));
          formdata.append("email_to", JSON.stringify(data.email_to));
          // formdata.append("amount", JSON.stringify(data.amount));
          Files.map((items) => formdata.append("files", items));
          console.log(
            {
              ...data,
              amount: data.amount,
              invoice_id: data.invoice_id,
              file_path: data.file_path,
              email_cc: data.email_cc,
              email_to: data.email_to,
            },
            "formdataasfdasdfaf"
          );
          for (var pair of formdata.entries()) {
            //console.log(pair[0] + ", " + pair[1]);
          }
          dispatch(CreateScheduleActions(formdata));

          // alert("djhfgj")
        } else {
          toast.info(`Unable To Send Mail Some Folders Are Empty`, {
            position: toast.POSITION.TOP_RIGHT,
            className: "toast-message",
          });
        }
      }
    } else {
      seterror(true);
    }
  };

  useEffect(() => {
    if (
      Object.keys(createScheduleResponse).length > 0 &&
      createScheduleResponse.status.code === 200
    ) {
      Swal.fire({
        title: "Successful.",
        text: "Report added successful.",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        iconColor: "#f26639",
        animation: true,
      });
      setData({
        email_to: [],
        email_cc: [],
        subject: "",
        email_body: "",
        plant: [],
        plant_name: "",
        project_name: [],
        project_name: "",
        project_wbs_name: [],
        project_wbs_name: "",
        file_path: [],
        amount: "",
        schedule_datetime: "",
      });
      setSelectedDate(null);

      setcontactname("");
      setcontactno("");
      setPlantSelected([]);
      setProjectSelected([]);
      setProjectWbsSelected([]);
      setckInitEditor("");
      setTreeNameFeeder([]);
      dispatch(UpdateScheduleResponse([]));
      setTreeFileSelected([]);
      setTreeFileSelectedproject([]);
      setTreeFileSelectedprojectwbs([]);
      setTreeNameFeeder([]);
      setTreeNameFeederproject([]);
      setTreeNameFeederprojectwbs([]);
      setFiles([]);
      setSelectedFiles([]);
      window.location.reload();
    }
  }, [createScheduleResponse]);

  useEffect(() => {
    setckInitEditor(
      `
        <p>Dear Sir / Madam</p> 
     
    <p>Greetings from UDS!</p> 
     
   <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
     
    <p>Please find attached invoices along with support documents for services rendered month of: ${
      date != "" ? date : ""
    }</p>
<p>Invoice# <br/>
[
  ${
    treeFileSelected.length > 0
      ? treeFileSelected
          .map((ele, index) => {
            var filenameWithExtension = ele.substring(ele.lastIndexOf("/") + 1); // Extract filename with extension
            var filenameWithoutExtension = filenameWithExtension.substring(
              0,
              filenameWithExtension.lastIndexOf(".")
            );

            //console.log(lastName);
            if (
              ele.includes("DIG_INVOICE") ||
              ele.includes("dig_invoice")
              // ele.includes("INVOICE") ||
              // ele.includes("invoice")
            ) {
              return `${`<span>${filenameWithoutExtension},</span>`}`;
            }
          })
          .join("")
      : ""
  }

        ${
          treeFileSelectedproject.length > 0
            ? treeFileSelectedproject
                .map((ele, index) => {
                  var filenameWithExtension1 = ele.substring(
                    ele.lastIndexOf("/") + 1
                  ); // Extract filename with extension
                  var filenameWithoutExtension1 =
                    filenameWithExtension1.substring(
                      0,
                      filenameWithExtension1.lastIndexOf(".")
                    );

                  if (
                    ele.includes("DIG_INVOICE") ||
                    ele.includes("dig_invoice")
                    // ele.includes("INVOICE") ||
                    // ele.includes("invoice")
                  ) {
                    return `${`<span>${filenameWithoutExtension1},</span>`}`;
                  }
                })
                .join("")
            : ""
        }
        ${
          treeFileSelectedprojectwbs.length > 0
            ? treeFileSelectedprojectwbs
                .map((ele, index) => {
                  // const lastName2 = ele
                  //   .substring(ele.lastIndexOf("/") + 1)
                  //   .split(".")[0];
                  var filenameWithExtension2 = ele.substring(
                    ele.lastIndexOf("/") + 1
                  ); // Extract filename with extension
                  var filenameWithoutExtension2 =
                    filenameWithExtension2.substring(
                      0,
                      filenameWithExtension2.lastIndexOf(".")
                    );

                  if (
                    ele.includes("DIG_INVOICE") ||
                    ele.includes("dig_invoice")
                    // ele.includes("INVOICE") ||
                    // ele.includes("invoice")
                  ) {
                    return `${`<span>${filenameWithoutExtension2},</span>`}`;
                  }
                })
                .join("")
            : ""
        }
      ]

</p> 

<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p>
  ${
    treeFileSelected.length > 0
      ? treeFileSelected
          .map((ele, index1) => {
            const pathSegments = ele.split("/");
            //console.log(pathSegments);
            const lastName = pathSegments[pathSegments.length - 2];
            //console.log(lastName);
            if (!encounteredLastNames.has(lastName)) {
              encounteredLastNames.add(lastName);
              return `${`${serialNumber++}. <span>${lastName}</span>`}`;
            }
            return null;
          })
          .filter(Boolean)
          .join("<br/>")
      : ""
  }
  <br/>
        ${
          treeFileSelectedproject.length > 0
            ? treeFileSelectedproject
                .map((ele, index2) => {
                  const pathSegments1 = ele.split("/");
                  //console.log(pathSegments1);
                  const lastName1 = pathSegments1[pathSegments1.length - 2];
                  //console.log(lastName1);
                  if (!encounteredLastNames1.has(lastName1)) {
                    encounteredLastNames1.add(lastName1);
                    return `${`${serialNumber++}. <span>${lastName1}</span>`}`;
                  }
                  return null;
                })
                .filter(Boolean)
                .join("<br/>")
            : ""
        }
        <br/>
        ${
          treeFileSelectedprojectwbs.length > 0
            ? treeFileSelectedprojectwbs
                .map((ele, index3) => {
                  const pathSegments2 = ele.split("/");
                  //console.log(pathSegments2);
                  const lastName2 = pathSegments2[pathSegments2.length - 2];
                  //console.log(lastName2);
                  if (!encounteredLastNames2.has(lastName2)) {
                    encounteredLastNames2.add(lastName2);
                    return `${`${serialNumber++}. <span>${lastName2}</span>`}`;
                  }
                  return null;
                })
                .filter(Boolean)
                .join("<br/>")
            : ""
        }
        <p>The invoice is digitally signed, Kindly write back to us to the below email ID in case of any clarification or dispute in this.</p>
        ${
          plantemails != null && plantemails.length > 0
            ? plantemails
                .map((ele) => {
                  return `${`<a>${ele}</a><br/>`}`;
                })
                .join("")
            : ""
        }

`
    );
    setData((prev) => {
      return {
        ...prev,
        email_body: `
        <p>Dear Sir / Madam</p> 
     
    <p>Greetings from UDS!</p> 
     
   <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
     
    <p>Please find attached invoices along with support documents for services rendered month of: ${
      date != "" ? date : ""
    }</p>
<p>Invoice# <br/>
[
  ${
    treeFileSelected.length > 0
      ? treeFileSelected
          .map((ele, index) => {
            const lastName = ele
              .substring(ele.lastIndexOf("/") + 1)
              .split(".")[0];
            //console.log(lastName);
            if (
              ele.includes("DIG_INVOICE") ||
              ele.includes("dig_invoice")
              // ele.includes("INVOICE") ||
              // ele.includes("invoice")
            ) {
              return `${`<span>${lastName},</span>`}`;
            }
          })
          .join("")
      : ""
  }

        ${
          treeFileSelectedproject.length > 0
            ? treeFileSelectedproject
                .map((ele, index) => {
                  const lastName1 = ele
                    .substring(ele.lastIndexOf("/") + 1)
                    .split(".")[0];
                  if (
                    ele.includes("DIG_INVOICE") ||
                    ele.includes("dig_invoice")
                    // ele.includes("INVOICE") ||
                    // ele.includes("invoice")
                  ) {
                    return `${`<span>${lastName1},</span>`}`;
                  }
                })
                .join("")
            : ""
        }
        ${
          treeFileSelectedprojectwbs.length > 0
            ? treeFileSelectedprojectwbs
                .map((ele, index) => {
                  const lastName2 = ele
                    .substring(ele.lastIndexOf("/") + 1)
                    .split(".")[0];
                  if (
                    ele.includes("DIG_INVOICE") ||
                    ele.includes("dig_invoice")
                    // ele.includes("INVOICE") ||
                    // ele.includes("invoice")
                  ) {
                    return `${`<span>${lastName2},</span>`}`;
                  }
                })
                .join("")
            : ""
        }
      ]

</p> 

<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p>
  ${
    treeFileSelected.length > 0
      ? treeFileSelected
          .map((ele, index1) => {
            const pathSegments = ele.split("/");
            //console.log(pathSegments);
            const lastName = pathSegments[pathSegments.length - 2];
            //console.log(lastName);
            if (!encounteredLastNames3.has(lastName)) {
              encounteredLastNames3.add(lastName);
              return `${`${serialNumber2++}. <span>${lastName}</span>`}`;
            }
            return null;
          })
          .filter(Boolean)
          .join("<br/>")
      : ""
  }
  <br/>
        ${
          treeFileSelectedproject.length > 0
            ? treeFileSelectedproject
                .map((ele, index2) => {
                  const pathSegments1 = ele.split("/");
                  //console.log(pathSegments1);
                  const lastName1 = pathSegments1[pathSegments1.length - 2];
                  //console.log(lastName1);
                  if (!encounteredLastNames4.has(lastName1)) {
                    encounteredLastNames4.add(lastName1);
                    return `${`${serialNumber2++}. <span>${lastName1}</span>`}`;
                  }
                  return null;
                })
                .filter(Boolean)
                .join("<br/>")
            : ""
        }
        <br/>
        ${
          treeFileSelectedprojectwbs.length > 0
            ? treeFileSelectedprojectwbs
                .map((ele, index3) => {
                  const pathSegments2 = ele.split("/");
                  //console.log(pathSegments2);
                  const lastName2 = pathSegments2[pathSegments2.length - 2];
                  //console.log(lastName2);
                  if (!encounteredLastNames5.has(lastName2)) {
                    encounteredLastNames5.add(lastName2);
                    return `${`${serialNumber2++}. <span>${lastName2}</span>`}`;
                  }
                  return null;
                })
                .filter(Boolean)
                .join("<br/>")
            : ""
        }
        <p>The invoice is digitally signed, Kindly write back to us to the below email ID in case of any clarification or dispute in this.</p>
        ${
          plantemails != null && plantemails.length > 0
            ? plantemails
                .map((ele) => {
                  return `${`<a>${ele}</a><br/>`}`;
                })
                .join("")
            : ""
        }

`,
      };
    });
  }, [
    treeFileSelected,
    treeFileSelectedproject,
    treeFileSelectedprojectwbs,
    projectSelected,
    date,
    serialNumber,
    serialNumber2,
    plantemails,
  ]);

  const projectwbsselect = (e) => {
    setCurrentChangedInput("");
    if (e) {
      setCurrentChangedInput("input3");
      setfilevalidation(false);
      setFieldErrors((prev) => {
        return {
          ...prev,
          plant: "",
        };
      });
      setProjectWbsSelected([{ value: e.value, label: e.label }]);
      setData((prev) => {
        return {
          ...prev,
          project_wbs_name: e.label,
          project_wbs: e.value,
        };
      });
    } else {
      setfilevalidation(false);
      dispatch(SetFileListUpdateprojectwbsSuccessResponse([]));
      setTreeNameFeederprojectwbs([]);

      setFieldErrors((prev) => {
        return {
          ...prev,
          plant: "",
        };
      });
      setProjectWbsSelected([]);
      setData((prev) => {
        return {
          ...prev,
          project_wbs_name: "",
          project_wbs: "",
          email_cc: [],
        };
      });
      const payload = {
        directory_path: `${plantSelected[0]?.label}`,
        plant: "True",
      };
      dispatch(setFileListRetrieveActions(payload));

      setTimeout(() => {
        dispatch(
          setFileListRetrieveActions(
            `${plantSelected[0]?.label}/${projectSelected[0]?.label}/`
          )
        );
      }, 1000);
      setTimeout(() => {
        setEmailSent((prevEmailSent) => [
          {
            ...prevEmailSent[0],
            input3: null,
          },
        ]);
      }, 100);
    }
  };
  const config = {
    allowedContent: true,
    toolbar: [
      {
        name: "basicstyles",
        items: ["Bold", "Italic", "Strike", "-", "RemoveFormat"],
      },
    ],
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    const fileArray1 = Array.from(files).filter((file) => file instanceof File);

    //console.log(fileArray1, "Selected files");

    setFiles((prev) => [...prev, ...fileArray1]);

    const filesArray = Array.from(e.target.files); // Convert FileList to array
    //console.log(filesArray, "kkj");
    filesArray.map((ele) => {
      setfiletypearray((prev) => [...prev, ele.type]);
    });
    filesArray.forEach((ele) => {
      setSelectedFiles((oldArray) => [
        ...oldArray,
        String(URL.createObjectURL(ele)),
      ]);
    });
  };
  const getFileExtension = (filename) => {
    //console.log(filename, "dsada");
    return filename.split(".").pop();
  };
  const test = async (e) => {
    //console.log(filedownload + `?file_path=${e.value}`, "789");
    // window.open(filedownload + `?file_path=${e.value}`, "_blank");
    try {
      const response = await axios.get(filedownload + `?file_path=${e.value}`, {
        responseType: "blob", // Tell Axios to expect a binary response
      });

      // Create a File from the Blob response
      const file = new File(
        [response.data],
        e.value.substring(e.value.lastIndexOf("/") + 1),
        { type: response.headers["content-type"] }
      );

      // Check the file extension to determine the file type
      const fileExtension = getFileExtension(file.name);
      //console.log(fileExtension, "fileExtension");
      if (fileExtension === "pdf") {
        // Open PDF file
        window.open(URL.createObjectURL(file), "_blank");
      } else if (fileExtension === "xlsx" || fileExtension === "xls") {
        // Open Excel file
        alert("This is an Excel file");
      } else {
        // Unsupported file type
        alert("Unsupported file type");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const deleteFile = (e) => {
    const w = selectedFiles.filter((item, index) => index !== e);
    setSelectedFiles(w);
    const v = Files.filter((item, index) => index !== e);
    setFiles(v);
    const z = filetypearray.filter((item, index) => index !== e);
    setfiletypearray(z);
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "outterContent "}>
        <div className="mainCreateFormDiv">
          <Header breadCrumbsData={breadcrumbsData} heading="DIGITAL INVOICE" />

          <div className="CreateFormModalBody">
            <form
              onSubmit={(e) => {
                HandleSubmits(e);
              }}
              className="row"
            >
              {/* ------------PLANT------------- */}
              <div className="col-sm-12 col-lg-4 col-md-6 col-form">
                <label htmlFor="plant" className="form-label">
                  {" "}
                  PLANT<span style={{ color: "red" }}>*</span>
                </label>
                <div>
                  <Select
                    className="Selects"
                    styles={customStyles}
                    isClearable={true}
                    onChange={(e) => {
                      serialNumber = 1;
                      serialNumber2 = 1;
                      setInvoiceFileList([]);
                      if (e) {
                        //console.log(e,"dahgajdhgj")
                        setfilevalidation(false);
                        setFieldErrors((prev) => {
                          return {
                            ...prev,
                            plant: "",
                          };
                        });
                        setPlantSelected([{ value: e.value, label: e.label }]);
                        const emails = plantNameFeeder.find(
                          (obj) => obj.id === e.value
                        );
                        setData({
                          ...data,
                          plant: e.value,
                          plant_name: e.label,
                          email_to: [],
                          subject: "",
                          email_body: "",
                          email_cc: emails?.emails, // Use emails.emails if available, otherwise use an empty array
                        });
                        setplantcc(emails?.emails);

                        setProjectSelected([]);
                        setProjectWbsSelected([]);
                        setProjectWbsNameFeeder([]);
                        setTreeNameFeeder([]);
                        setTreeNameFeederproject([]);
                        setTreeNameFeederprojectwbs([]);
                        setckInitEditor("");
                        setcontactname("");
                        setcontactno("");
                        dispatch(SetFileListUpdateSuccessResponse([]));
                        dispatch(SetFileListUpdateprojectSuccessResponse([]));
                        dispatch(
                          SetFileListUpdateprojectwbsSuccessResponse([])
                        );
                        setTreeNameFeeder([]);
                        setTreeNameFeederproject([]);
                        setTreeNameFeederprojectwbs([]);
                        setTreeFileSelected([]);
                        setTreeFileSelectedproject([]);
                        setTreeFileSelectedprojectwbs([]);
                        setCurrentChangedInput("input1");
                      } else {
                        setfilevalidation(false);
                        dispatch(SetFileListUpdateSuccessResponse([]));
                        dispatch(SetFileListUpdateprojectSuccessResponse([]));
                        dispatch(
                          SetFileListUpdateprojectwbsSuccessResponse([])
                        );
                        setTreeNameFeeder([]);
                        setTreeNameFeederproject([]);
                        setTreeNameFeederprojectwbs([]);
                        setTreeFileSelected([]);
                        setTreeFileSelectedproject([]);
                        setTreeFileSelectedprojectwbs([]);

                        setFieldErrors((prev) => {
                          return {
                            ...prev,
                            plant: "",
                          };
                        });
                        setPlantSelected([]);
                        setData({
                          ...data,
                          plant: "",
                          plant_name: "",
                          email_to: [],
                          email_cc: [],
                          subject: "",
                          file_path: [],
                          project: "",
                          project_name: "",
                          project_wbs: "",
                          project_wbs_name: "",
                        });
                        setplantcc([]);
                        setProjectSelected([]);
                        setProjectWbsSelected([]);
                        setProjectWbsNameFeeder([]);
                        setckInitEditor("");
                        setcontactname("");
                        setcontactno("");
                        setCurrentChangedInput("");
                        setTimeout(() => {
                          setEmailSent((prevEmailSent) => [
                            {
                              ...prevEmailSent[0],
                              input1: null,
                              input2: null,
                              input3: null,
                            },
                          ]);
                        }, 100);
                      }
                    }}
                    name="plant"
                    id="plant"
                    options={plantNameFeeder?.map(({ id, plant }) => ({
                      value: id,
                      label: plant,
                    }))}
                    value={plantSelected}
                  />
                </div>
                {fieldErrors.plant ? (
                  <div
                    className="error"
                    style={{
                      color: "#626262",
                      padding: "5px",
                    }}
                  >
                    {fieldErrors.plant}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                ) : (
                  ""
                )}

                {/* -----------Project--------------- */}
                <label htmlFor="project" className="form-label">
                  {" "}
                  PROJECT<span style={{ color: "red" }}>*</span>
                </label>
                <div>
                  <Select
                    className="Selects"
                    isClearable={true}
                    styles={customStyles}
                    onChange={(e) => {
                      if (e) {
                        setfilevalidation(false);

                        handleMail(e.value);
                        setProjectSelected([
                          { value: e.value, label: e.label },
                        ]);
                        setData((prev) => {
                          return {
                            ...prev,
                            project_name: e.label,
                            project: e.value,
                            email_body: `
                            <p>Dear Sir / Madam</p> 
                         
                        <p>Greetings from UDS!</p> 
                         
                       <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
                         
                        <p>Please find attached invoices along with support documents for services rendered month of: ${
                          date != "" ? date : ""
                        }</p>
<p>Invoice# <br/></p> 
<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p> `,
                          };
                        });
                        setFieldErrors((prev) => {
                          return {
                            ...prev,
                            project_name: "",
                          };
                        });
                        setProjectWbsSelected([]);
                        setCurrentChangedInput("input2");
                      } else {
                        // Remove
                        setCurrentChangedInput("");
                        setTimeout(() => {
                          setEmailSent((prevEmailSent) => [
                            {
                              ...prevEmailSent[0],
                              input2: null,
                              input3: null,
                            },
                          ]);
                        }, 100);

                        setfilevalidation(false);
                        dispatch(SetFileListUpdateprojectSuccessResponse([]));
                        dispatch(
                          SetFileListUpdateprojectwbsSuccessResponse([])
                        );
                        setTreeNameFeederproject([]);
                        setTreeNameFeederprojectwbs([]);

                        handleMail("");
                        setProjectSelected([]);
                        setData((prev) => {
                          return {
                            ...prev,
                            project_name: "",
                            project: "",
                            email_cc: plantcc,

                            email_body: `
                            <p>Dear Sir / Madam</p> 
                         
                        <p>Greetings from UDS!</p> 
                         
                       <p> We trust this message finds you well. Attached below is the link to the invoice and accompanying documents. As part of our transition to digital delivery, we will continue to provide physical invoices and supporting documents time being, alongside the digital delivery to facilitate the transition process. Following this initial phase, invoices and support documents will be exclusively delivered through digital mode.</p>
                         
                        <p>Please find attached invoices along with support documents for services rendered month of: ${
                          date != "" ? date : ""
                        }</p>
<p>Invoice# <br/> </p> 
<p>Please find the link below to download your invoice:</p>
<p><a href="{{ invoice_download_link }}">Download Invoice</a></p>
<p>Enclosures</p> `,
                          };
                        });
                        setFieldErrors((prev) => {
                          return {
                            ...prev,
                            project_name: "",
                          };
                        });
                        setProjectWbsSelected([]);
                      }
                    }}
                    name="project"
                    options={
                      plantSelected.length !== 0
                        ? projectNameFeeder?.map(({ id, project }) => ({
                            value: id,
                            label: project,
                          }))
                        : [
                            {
                              value: "noneSelected",
                              label: "Select a plant to view projects.",
                              isDisabled: true,
                            },
                          ]
                    }
                    value={projectSelected}
                  />
                </div>
                {fieldErrors.project ? (
                  <div
                    className="error"
                    style={{
                      color: "#626262",
                      height: "20px",
                      padding: "5px",
                    }}
                  >
                    {fieldErrors.project}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                ) : (
                  ""
                )}
                {/* <----------------Project WBS---------------------> */}
                <label htmlFor="plant" className="form-label">
                  {" "}
                  PROJECT WBS
                </label>
                <div>
                  <Select
                    className="Selects"
                    isClearable={true}
                    styles={customStyles}
                    onChange={(e) => {
                      projectwbsselect(e);
                    }}
                    name="plant"
                    id="plant"
                    options={projectWbsNameFeeder?.map(
                      ({ id, project_wbs }) => ({
                        value: id,
                        label: project_wbs,
                      })
                    )}
                    value={projectWbsSelected}
                  />
                </div>
                <label htmlFor="plant" className="form-label">
                  {" "}
                  INVOICE MONTH
                  <span style={{ color: "red", padding: "10px 0 20px" }}>
                    *
                  </span>
                </label>

                <DatePicker
                  // shouldDisableDate={date => isBefore(date, new Date())}
                  format="MM-yyyy"
                  placement="auto"
                  className="w-100"
                  onChange={(e) => {
                    var date = new Date(e);

                    var month = date.toLocaleString("en-us", {
                      month: "short",
                    }); // Get the short month name
                    var year = date.getFullYear();

                    setDate(month + " " + year);
                    setData({
                      ...data,
                      month_year: month + " " + year,
                    });
                  }}
                />
                {console.log(date, "kjdkjkaskjksjlkas")}
                {error && date == "" ? (
                  <div
                    className="error"
                    style={{
                      color: "#626262",
                      padding: "5px",
                    }}
                  >
                    Invoice Month Required
                    <span style={{ color: "red" }}>*</span>
                  </div>
                ) : (
                  ""
                )}
                <label className="form-label">
                  CUSTOMER NAME
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  name="contact_name"
                  value={contactname}
                  onChange={(e) => {
                    setcontactname(e.target.value);
                  }}
                  // disabled={data.project != "" && data.project != [] ? false : true}
                />
                {error && contactname == "" ? (
                  <div
                    className="error"
                    style={{
                      color: "#626262",
                      padding: "5px",
                    }}
                  >
                    Contact Name Required
                    <span style={{ color: "red" }}>*</span>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <label htmlFor={"datePicker"} className="form-label">
                    Invoice Amount (₹)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    autoComplete="off"
                    name="amount"
                    value={invoiceAmount}
                    type="text"
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/,/g, "");
                      const numericValue = parseInt(rawValue, 10);

                      if (
                        !isNaN(numericValue) &&
                        String(numericValue).length <= 10
                      ) {
                        const formattedValue = numericValue.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        );

                        setData({
                          ...data,
                          amount: String(numericValue),
                        });
                        setinvoiceAmount(formattedValue);
                      } else if (rawValue === "") {
                        setData({ ...data, amount: "" });
                        setinvoiceAmount("");
                      }
                    }}
                  />
                  {fieldErrors?.amount?.length > 0 ? (
                    <div
                      className="error"
                      style={{
                        color: "#626262",
                        padding: "5px",
                      }}
                    >
                      {fieldErrors?.amount}
                      <span style={{ color: "red" }}>*</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <label className="form-label">
                  CUSTOMER NUMBER
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control"
                  autoComplete="off"
                  name="contact_no"
                  value={contactno}
                  // disabled={data.project != "" && data.project != [] ? false : true}
                  type="number"
                  onChange={(e) => {
                    if (e.target.value.length != 11) {
                      setcontactno(e.target.value);
                    }
                  }}
                />
                {error && contactno == "" ? (
                  <div
                    className="error"
                    style={{
                      color: "#626262",
                      padding: "5px",
                    }}
                  >
                    Contact Number Required
                    <span style={{ color: "red" }}>*</span>
                  </div>
                ) : (
                  ""
                )}
                <div className="dateTimeDiv">
                  <div>
                    <label htmlFor={"datePicker"} className="form-label">
                      SCHEDULE DATE TIME{" "}
                    </label>
                    {/* <DatePicker
                      format="MM/dd/yyyy HH:mm"
                      className="w-100"
                      placement="auto"
                      // value={data.schedule_datetime}
                      // defaultValue={new Date()}
                      selected={new Date()}
                      minDate={new Date()}
                      // shouldDisableDate={(date) => isBefore(date, new Date()) && !isSameDay(date, new Date())}
                      // shouldDisableHour={(hour) => hour < 8 || hour > 18}
                      // shouldDisableMinute={minute => minute % 15 !== 0}
                      // shouldDisableSecond={second => second % 30 !== 0}
                      shouldDisableDate={(date) => {
                        const currentDate = new Date();
                        // Disable past dates excluding today
                        if (
                          isBefore(date, currentDate) &&
                          !isSameDay(date, currentDate)
                        ) {
                          return true;
                        }

                        // Disable past times for the current date
                        if (isSameDay(date, currentDate)) {
                          const currentHour = currentDate.getHours();
                          const currentMinute = currentDate.getMinutes();
                          const selectedHour = date.getHours();
                          const selectedMinute = date.getMinutes();
                          // If the selected time is earlier than the current time, disable it
                          if (
                            selectedHour < currentHour ||
                            (selectedHour === currentHour &&
                              selectedMinute < currentMinute)
                          ) {
                            return true;
                          }
                        }
                        return false;
                      }}
                      onChange={(e) => {
                        //console.log(e);
                        handleDate(e);
                      }}
                      editable={false}
                    /> */}
                    <DatePicker
                      format="MM/dd/yyyy HH:mm"
                      className="w-100"
                      placement="auto"
                      selected={new Date()}
                      value={selectedDate}
                      minDate={new Date()}
                      shouldDisableDate={(date) => {
                        const currentDate = new Date();
                        const yesterday = new Date();
                        yesterday.setDate(currentDate.getDate() - 1); // Get yesterday's date
                        // Disable dates before yesterday
                        return isBefore(date, yesterday);
                      }}
                      shouldDisableHour={(hour) => hour < new Date().getHours()}
                      shouldDisableMinute={(minute, hour) => {
                        const currentDate = new Date();
                        const currentHour = currentDate.getHours();
                        // If the selected hour is the current hour, disable past minutes
                        if (hour === currentHour) {
                          return minute < currentDate.getMinutes();
                        }
                        // For future hours, all minutes are enabled
                        return false;
                      }}
                      onChange={(e) => {
                        handleDate(e);
                      }}
                      editable={false}
                    />

                    {/* {fieldErrors.schedule_datetime ? (
                      <div
                        className="error"
                        style={{
                          color: "#626262",
                          height: "20px",
                          padding: "5px",
                        }}
                      >
                        {fieldErrors.schedule_datetime}
                        <span style={{ color: "red" }}>*</span>
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-4 col-md-6 col-form">
                <div className="">
                  {inputFields.map((field, index) => (
                    <div key={index}>
                      <label htmlFor={field.id} className="form-label">
                        {field.label}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id={field.id}
                        autoComplete="off"
                        name={field.name}
                        value={field.value}
                        onChange={(e) => {
                          HandleChanges(e);
                        }}
                        disabled={
                          field.name === "email_to"
                            ? // &&
                              // data.email_to.length === 0
                              false
                            : field.name === "email_to" &&
                              data.email_to.length !== 0 &&
                              true
                        }
                      />
                      {fieldErrors[field.name] ? (
                        <div
                          className="error"
                          style={{
                            color: "#626262",
                            height: "20px",
                            padding: "5px",
                          }}
                        >
                          {fieldErrors[field.name]}
                          <span style={{ color: "red" }}>*</span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}

                  <label htmlFor="to" className="form-label">
                    {" "}
                    To
                  </label>
                  <div className="ccMailDiv">
                    <TagsInput
                      value={data.email_to}
                      id="taginput"
                      onChange={(tags) => {
                        // // eslint-disable-next-line no-lone-blocks
                        // {
                        //   altMethod
                        //     ? setEmail(
                        //         tags.filter(
                        //           (tag) => !data?.email_to.includes(tag)
                        //         )
                        //       )
                        //     :
                        setData({
                          ...data,
                          email_to: tags,
                        });
                        // }
                      }}
                      validationRegex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                      addOnBlur={true}
                      addOnPaste={true}
                      className="react-tagsinput-language"
                      name="languages_known"
                      inputProps={{
                        placeholder: "Add To",
                      }}
                    />
                  </div>
                  {/* -----------Cc--------------- */}
                  <label htmlFor="cc" className="form-label">
                    {" "}
                    Cc
                  </label>
                  {console.log(data, "dajkshkashdhsalkhkldjsa")}
                  <div className="ccMailDiv">
                    <TagsInput
                      value={data?.email_cc}
                      id="taginput"
                      onChange={(tags) => {
                        setData({
                          ...data,
                          email_cc: tags,
                        });
                      }}
                      validationRegex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                      addOnBlur={true}
                      addOnPaste={true}
                      className="react-tagsinput-language"
                      name="languages_known"
                      inputProps={{
                        placeholder: "Add Cc",
                      }}
                    />
                  </div>
                  {/* -----------Email body--------------- */}
                  <div style={{ marginTop: "30px" }}>
                    <CKEditor
                      id="email_body"
                      name="email_body"
                      config={config}
                      initData={ckInitEditor}
                      key={ckInitEditor}
                      onChange={(e) => {
                        // setckInitEditor(e.editor.getData());
                        //console.log();
                        setData((prev) => {
                          return {
                            ...prev,
                            email_body: e.editor.getData(),
                          };
                        });
                      }}
                    />

                    {fieldErrors.email_body ? (
                      <div
                        className="error"
                        style={{
                          color: "#626262",
                          height: "20px",
                          padding: "5px",
                        }}
                      >
                        {fieldErrors.email_body}
                        <span style={{ color: "red" }}>*</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              {console.log(treeNameFeederproject, "kjlsdhkasjdhjasjlkd")}

              <div className="col-sm-12 col-lg-4 col-md-6 col-form">
                {/* -----------Document Selection--------------- */}
                <label className="form-label">
                  CHOOSE THE DOCUMENT<span style={{ color: "red" }}>*</span>
                </label>
                <div className="checkBoxDiv">
                  {treeNameFeeder.length > 0 ? (
                    <CheckboxTree
                      nodes={treeNameFeeder}
                      // nodes={nodes}
                      checked={treeFileSelected}
                      expanded={expanded}
                      onCheck={onCheck}
                      onExpand={onExpand}
                      icons={customIcons}
                      onClick={(e) => {
                        test(e);
                      }}
                      onlyLeafCheckboxes={true}
                    />
                  ) : (
                    // <p>
                    //   <span>Select a project to list related documents.</span>
                    // </p>
                    ""
                  )}
                </div>
                <div className="checkBoxDiv">
                  {treeNameFeederproject.length > 0 ? (
                    <CheckboxTree
                      nodes={treeNameFeederproject}
                      // nodes={nodes}
                      checked={treeFileSelectedproject}
                      expanded={expandedproject}
                      onCheck={onCheck1}
                      onExpand={onExpand1}
                      icons={customIcons}
                      onClick={(e) => {
                        test(e);
                      }}
                      onlyLeafCheckboxes={true}
                    />
                  ) : (
                    // <p>
                    //   <span>Select a project to list related documents.</span>
                    // </p>
                    ""
                  )}
                </div>
                <div className="checkBoxDiv">
                  {treeNameFeederprojectwbs.length > 0 ? (
                    <CheckboxTree
                      nodes={treeNameFeederprojectwbs}
                      checked={treeFileSelectedprojectwbs}
                      expanded={expandedprojectwbs}
                      onCheck={onCheck2}
                      onExpand={onExpand2}
                      icons={customIcons}
                      onClick={(e) => {
                        test(e);
                      }}
                      onlyLeafCheckboxes={true}
                    />
                  ) : (
                    // <p>
                    //   <span>Select a project to list related documents.</span>
                    // </p>
                    ""
                  )}
                </div>
                <div class="col-md-12 p-1 m-0">
                  <div className="form-group preview">
                    <div className="imgouters" style={{ display: "flex" }}>
                      {/* {selectedFiles &&
                        selectedFiles.length > 0 &&
                        selectedFiles.map((item, index) => {
                          return (
                            <>
                              <img
                                onClick={(e) => {
                                  window.open(item);
                                }}
                                className="pointer"
                                style={{
                                  height: "2.5rem",
                                  width: "2.5rem",
                                  borderRadius: "50%",
                                  margin: "10px 10px 10px 20px",
                                }}
                                src={item}
                                alt=""
                              />
                              <button
                                type="button"
                                style={{
                                  position: "relative",
                                  height: "20px",
                                  width: "20px",
                                  margin: "-10px",
                                  borderRadius: "50%",
                                  backgroundColor: "#1b5a90",
                                }}
                                onClick={() => deleteFile(index)}
                              >
                                <i
                                  class="bi bi-x"
                                  style={{
                                    margin: "inherit",
                                    color: "white",
                                    position: "relative",
                                    bottom: "2px",
                                  }}
                                ></i>
                              </button>
                            </>
                          );
                        })} */}
                      {selectedFiles.map((item, index) => {
                        return (
                          <>
                            {filetypearray[index] != "image/png" &&
                            filetypearray[index] != "image/jpeg" ? (
                              <div>
                                {/* Render PDF icon or image here */}
                                <img
                                  src={pdf}
                                  alt="PDF"
                                  style={{
                                    height: "2.5rem",
                                    width: "2.5rem",
                                    borderRadius: "50%",
                                    margin: "10px 10px 10px 20px",
                                  }}
                                />
                              </div>
                            ) : (
                              <div>
                                {/* Render image */}
                                <img
                                  onClick={(e) => {
                                    window.open(item);
                                  }}
                                  className="pointer"
                                  style={{
                                    height: "2.5rem",
                                    width: "2.5rem",
                                    borderRadius: "50%",
                                    margin: "10px 10px 10px 20px",
                                  }}
                                  src={item}
                                  alt=""
                                />
                              </div>
                            )}
                            <button
                              type="button"
                              style={{
                                position: "relative",
                                height: "20px",
                                width: "20px",
                                margin: "-10px",
                                borderRadius: "50%",
                                backgroundColor: "#1b5a90",
                              }}
                              onClick={() => deleteFile(index)}
                            >
                              <i
                                className="bi bi-x"
                                style={{
                                  margin: "inherit",
                                  color: "white",
                                  position: "relative",
                                  bottom: "2px",
                                }}
                              ></i>
                            </button>
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <Button
                  className="fileupload"
                  variant="contained"
                  component="label"
                  // disabled={selectedFiles && selectedFiles.length > 5}
                >
                  {" "}
                  <input
                    type="file"
                    // disabled={selectedFiles && selectedFiles.length > 5}
                    hidden
                    className="form-control"
                    onChange={handleFileChange}
                    multiple
                  />
                  Upload Documents
                </Button>
                <div
                  style={{
                    width: "100%",
                    textAlign: "right",
                  }}
                >
                  <button
                    type="submit"
                    style={{
                      background:
                        "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
                    }}
                    className="custom-button"
                    onClick={(e) => {
                      HandleSubmits(e);
                    }}
                  >
                    {new Date(data.schedule_datetime) > currentDateTime
                      ? "SCHEDULE"
                      : "Send Now"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateMail;
